<!--<template>
  <div>
    <v-data-table :headers="headers" :search="search" :items="bonos" :loading="loadingTable">
      <template v-slot:top>
        <div class="d-flex justify-center">
          <v-btn color="primary" @click="mostrar_TiposUsuarios()">Crear Nuevo Bono</v-btn>
          <v-text-field class="ml-5" v-model="search" v-bind="propsSearch" />
        </div>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <v-tooltip bottom color="black">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-on="on" v-bind="attrs" small class="mr-1" @click="show_dialog(item)">mdi-eye</v-icon>
          </template>
          <span class="white--text">Editar</span>
        </v-tooltip>
        <v-tooltip bottom color="black">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-on="on" v-bind="attrs" small class="mr-1" @click="show_dialogDelete(item)">mdi-trash-can</v-icon>
          </template>
          <span class="white--text">Eliminar</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="700" persistent>
      <v-card>
        <v-card-title>{{ optionDialog }} Bono</v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-col cols="12">
              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="bonoData.codigo" label="Código" v-bind="propsText" />
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="bonoData.nombre" label="Nombre" v-bind="propsText" />
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <v-row>
                <v-col cols="6">
                  <v-autocomplete v-model="bonoData.idTurno" label="Turno" :items="turnos" item-text="nombre"
                    item-value="idTurno" v-bind="propsAutocomplete" />
                </v-col>
                <v-col cols="6">
                  <v-autocomplete v-model="bonoData.idArea" label="Área" :items="areas" item-text="nombre"
                    item-value="idArea" v-bind="propsAutocomplete" />
                </v-col>
                <v-col cols="6">
                  <v-autocomplete v-model="bonoData.idCargo" label="Puesto" :items="puestos" item-text="nombre"
                    item-value="idPuesto" v-bind="propsAutocomplete" />
                </v-col>
                <v-col cols="6">
                  <v-autocomplete v-model="bonoData.idMaquina" label="Máquina" :items="maquinas"
                    :item-text="nombreMaquina" item-value="idMaquina" v-bind="propsAutocomplete" />
                </v-col>
              </v-row>
              <v-text-field v-model="bonoData.numHabilidades" label="Número de habilidades" v-bind="propsDecimales1"
                @wheel.prevent />

              <v-simple-table height="auto">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center">
                        Concepto
                      </th>
                      <th class="text-center">
                        Porcentaje
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="concepto in bonoData.bonoConceptos" :key="concepto.idConceptoBono">
                      <td>{{ concepto.descripcion ? concepto.descripcion : "" }}</td>
                      <td><v-text-field v-model="concepto.porcentaje" label="Porcentaje" suffix="%"
                          v-bind="propsEnteros" /></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-form>
          <ul>
            <li class="red--text" v-for="ex in errores" :key="ex">{{ ex }}</li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <v-btn :loading="loadingDialog" color="success" class="ml-auto" text @click="hide_dialogBonos()">Cancelar</v-btn>
          <v-btn :loading="loadingDialog" color="error" text @click="validate()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEleccion" width="500">
      <v-card>
        <v-card-title>El Bono Aplica A:</v-card-title>
        <v-card-text class="d-flex justify-center align-center">
          <center>
            <v-row class="py-1">
              <v-btn-toggle v-model="bonoTipo" mandatory>
                <v-btn value="1" text style="width: 200px;" :class="btnClass">
                  Operadores
                </v-btn>

                <v-btn value="2" text style="width: 200px;" :class="btnClass">
                  Supervisores
                </v-btn>
              </v-btn-toggle>
            </v-row>
          </center>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="primary" class="ml-auto" @click="dialogEleccion = false">Cancelar</v-btn>
          <v-btn text color="success" @click="selectTipoUsuario()">Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDeleteBono" max-width="500" persistent>
      <v-card>
        <v-card-title>Eliminar Bono</v-card-title>
        <v-card-text class="text--primary">¿Desea Eliminar "[{{ bonoData.codigo }}] - {{ bonoData.nombre
          }}"?</v-card-text>
        <v-card-subtitle>Esta acción es permanente y no se puede deshacer</v-card-subtitle>
        <v-card-actions>
          <v-btn :loading="loadingDialog" color="success" class="ml-auto" text
            @click="hide_dialogDelete()">Cancelar</v-btn>
          <v-btn :loading="loadingDialog" color="error" text @click="deleteBono()">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>-->

<template>
  <v-col cols="12">
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialogDeleteBono" persistent max-width="500px" :key="eliminar">
          <v-card>
            <v-card-title class="headline">¿Está seguro que desea eliminar este Bono?</v-card-title>
            <v-card-text>Esta acción no se puede revertir y será permanente.</v-card-text>
            <v-card-actions>
              <v-btn color="blue darken-1" text @click="hide_dialogDelete()" class="ml-auto">Cancelar</v-btn>
              <v-btn color="red darken-1" text @click="deleteBono()">Aceptar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <v-data-table :headers="headers" :search="search" :items="bonos" :loading="loadingTable">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-dialog v-model="dialog" persistent max-width="700" :key="dialog">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on" @click="show_dialog()">Nuevo Bono</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ optionDialog == 1 ? "Crear Bono" : "Editar Bono" }}</span>
              </v-card-title>
              <v-card-text>
                <v-form ref="form">
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="6">
                        <v-text-field v-model="bonoData.codigo" label="Código" v-bind="propsText" />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field v-model="bonoData.nombre" label="Nombre" v-bind="propsText" />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col>
                    <v-row>
                      <v-col cols="6">
                        <v-autocomplete v-model="bonoData.idTurno" label="Turno [Opcional]" :items="turnos"
                          item-text="nombre" item-value="idTurno" v-bind="propsAutocompleteNull" />
                      </v-col>
                      <v-col cols="6">
                        <v-autocomplete v-model="bonoData.idArea" label="Área [Opcional]" :items="areas"
                          item-text="nombre" item-value="idArea" v-bind="propsAutocompleteNull" />
                      </v-col>
                      <v-col cols="6">
                        <v-autocomplete v-model="bonoData.idCargo" label="Puesto" :items="puestos" item-text="nombre"
                          item-value="idPuesto" v-bind="propsAutocomplete" />
                      </v-col>
                      <v-col cols="6">
                        <v-autocomplete v-model="bonoData.idMaquina" label="Máquina [Opcional]" :items="maquinas"
                          :item-text="nombreMaquina" item-value="idMaquina" v-bind="propsAutocompleteNull" />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field v-model="bonoData.numHabilidades" label="Número de habilidades"
                          v-bind="propsEnteros" @wheel.prevent />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field v-model="bonoData.total" label="Monto del bono" v-bind="propsDecimales1"
                          @wheel.prevent prefix="$" />
                      </v-col>
                      <v-col cols="12">
                        <v-text-field v-model="bonoData.dias" label="Periodo del bono en días" v-bind="propsEnteros1"
                          @wheel.prevent suffix="Días" />
                      </v-col>
                    </v-row>

                    <v-simple-table height="auto">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-center">
                              Concepto
                            </th>
                            <th class="text-center">
                              Porcentaje
                            </th>
                            <th class="text-center">
                              Objetivo
                            </th>
                            <th class="text-center">
                              Tolerancia
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="concepto in bonoData.bonoConceptos" :key="concepto.idConceptoBono">
                            <td>{{ concepto.descripcion ? concepto.descripcion : "" }}</td>
                            <td><v-text-field v-model="concepto.porcentaje" label="Porcentaje" suffix="%"
                                v-bind="propsEnteros" /></td>
                            <td><v-text-field v-model="concepto.objetivo" label="Objetivo"
                                :suffix="concepto.unidadObjetivo" v-bind="propsEnteros" /></td>
                            <td><v-text-field v-model="concepto.tolerancia" label="Tolerancia"
                                :suffix="concepto.unidadTolerancia" v-bind="propsEnteros" /></td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-form>
                <ul>
                  <li class="red--text" v-for="ex in errores" :key="ex">{{ ex }}</li>
                </ul>
              </v-card-text>
              <v-card-actions>
                <v-btn :loading="loadingDialog" color="blue darken-1" text @click="hide_dialogBonos()"
                  class="ml-auto">Cancelar</v-btn>
                <v-btn :loading="loadingDialog" color="red darken-1" text @click="validate()">Guardar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" v-bind="propsSearch" single-line hide-details />
        </v-toolbar>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <v-tooltip bottom color="black">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-on="on" v-bind="attrs" small class="mr-1" @click="show_dialog(item)">mdi-pen</v-icon>
          </template>
          <span class="white--text">Editar</span>
        </v-tooltip>
        <v-tooltip bottom color="black">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-on="on" v-bind="attrs" small class="mr-1" @click="show_dialogDelete(item)">mdi-trash-can</v-icon>
          </template>
          <span class="white--text">Eliminar</span>
        </v-tooltip>
      </template>
      <template v-slot:item.total="{ item }">
        ${{ item.total }}
      </template>
    </v-data-table>
    <v-snackbar v-model="alerta" top color="error">
      Existe una Habilidad Activa con el mismo nombre
      <v-btn text @click="alerta = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </v-col>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      btnClass: 'my-button-class',

      propsSearch: {
        clearable: true,
        label: "Buscar",
        clearIcon: 'mdi-close-circle',
        appendIcon: 'mdi-magnify',
        hideDetails: true,
        dense: true,
      },
      propsSearchAutocomplete: {
        outlined: false,
        dense: false,
        clearable: true,
        clearIcon: 'mdi-close-circle',
      },

      propsText: {
        outlined: false,
        dense: false,
        required: true,
        rules: [
          (v) => {
            if (v === null || v === "") {
              return "Dato requerido";
            }
            return true;
          },
        ],
      },
      propsTextArea: {
        required: true,
        rules: [
          (v) => !!v || "Dato Requerido"
        ],
      },
      propsAutocompleteNull: {
        outlined: false,
        dense: false,
        clearable: true,
        clearIcon: 'mdi-close-circle'
      },
      propsAutocomplete: {
        outlined: false,
        dense: false,
        clearable: true,
        clearIcon: 'mdi-close-circle',
        required: true,
        rules: [
          (v) => !!v || "Dato Requerido"
        ],
      },
      propsAutocompleteMultiple: {
        outlined: false,
        dense: false,
        clearable: true,
        clearIcon: 'mdi-close-circle',
        required: true,
        multiple: true,
        chips: true,
        rules: [
          (v) => !!v || "Dato Requerido"
        ],
      },
      propsSelect: {
        multiple: false,
        chips: false,
        dense: false,
        clearable: true,
        'clear-icon': "mdi-close-circle",
      },

      propsDecimales: {
        outlined: false,
        dense: false,
        type: "number",
        inputmode: "numeric",
        required: true,
        rules: [
          (v) => {
            if (v === null || v === "") {
              return "Dato requerido";
            } else if (!Number.isFinite(Number(v))) {
              return "Ingrese solo números";
            } else if (Number(v) < 0) {
              return "Dato no valido";
            }
            return true;
          },
        ],
      },
      propsDecimales1: {
        outlined: false,
        dense: false,
        type: "number",
        inputmode: "numeric",
        required: true,
        rules: [
          (v) => {
            if (v === null || v === "") {
              return "Dato requerido";
            } else if (!Number.isFinite(Number(v))) {
              return "Ingrese solo números";
            } else if (Number(v) < 1) {
              return "Dato no valido";
            }
            return true;
          },
        ],
      },
      propsEnteros: {
        outlined: false,
        dense: false,
        type: "number",
        inputmode: "numeric",
        required: true,
        rules: [
          (v) => {
            if (v === null || v === "") {
              return "Dato requerido";
            } else if (!Number.isFinite(Number(v))) {
              return "Ingrese solo números";
            } else if (!Number.isInteger(Number(v))) {
              return "Ingrese un número entero";
            } else if (Number(v) < 0) {
              return "Dato no valido";
            }
            return true;
          },
        ],
      },
      propsEnteros1: {
        outlined: false,
        dense: false,
        type: "number",
        inputmode: "numeric",
        required: true,
        rules: [
          (v) => {
            if (v === null || v === "") {
              return "Dato requerido";
            } else if (!Number.isFinite(Number(v))) {
              return "Ingrese solo números";
            } else if (!Number.isInteger(Number(v))) {
              return "Ingrese un número entero";
            } else if (Number(v) < 1) {
              return "Dato no valido";
            }
            return true;
          },
        ],
      },

      dialogEleccion: false,
      dialog: false,
      dialogDeleteBono: false,
      optionDialog: 1,

      search: "",

      bonoTipo: 1,
      /*bonoConceptosOperadores: [
        {
          idConceptoBono: 1,
          concepto: "Tiempo Muerto de la Máquina",
          porcentaje: null
        }, {
          idConceptoBono: 2,
          concepto: "Puntualidad",
          porcentaje: null
        }, {
          idConceptoBono: 3,
          concepto: "Asistencia",
          porcentaje: null
        }, {
          idConceptoBono: 4,
          concepto: "Productividad",
          porcentaje: null
        }, {
          idConceptoBono: 5,
          concepto: "Scrap",
          porcentaje: null
        }, {
          idConceptoBono: 6,
          concepto: "Retrabajo",
          porcentaje: null
        }, {
          idConceptoBono: 7,
          concepto: "Tiempo Muerto del Operador",
          porcentaje: null
        }
      ],
      bonoConceptosSupervisores: [
        {
          idConceptoBono: 1,
          concepto: "Tiempo Muerto de la Máquina",
          porcentaje: null
        }, {
          idConceptoBono: 2,
          concepto: "Puntualidad",
          porcentaje: null
        }, {
          idConceptoBono: 3,
          concepto: "Asistencia",
          porcentaje: null
        }, {
          idConceptoBono: 4,
          concepto: "Productividad",
          porcentaje: null
        }, {
          idConceptoBono: 5,
          concepto: "Scrap",
          porcentaje: null
        }, {
          idConceptoBono: 6,
          concepto: "Retrabajo",
          porcentaje: null
        }
      ],*/
      bonoData: {
        codigo: null,
        nombre: null,
        idTipo: null,
        idTurno: null,
        idArea: null,
        idCargo: null,
        idMaquina: null,
        numHabilidades: null,
        total: 0,
        dias: null,

        bonoConceptos: []
      },
      bonoDataDef: {
        codigo: null,
        nombre: null,
        idTipo: null,
        idTurno: null,
        idArea: null,
        idCargo: null,
        idMaquina: null,
        numHabilidades: null,
        total: 0,
        dias: null,

        bonoConceptos: []
      },
      headers: [
        {
          text: "Código",
          value: "codigo",
          align: "center",
          sortable: false
        }, {
          text: "Nombre",
          value: "nombre",
          align: "center",
          sortable: false
        }, {
          text: "Puesto",
          value: "nombreCargo",
          align: "center",
          sortable: false
        }, {
          text: "Monto",
          value: "total",
          align: "center",
          sortable: false
        },
        {
          text: "Acciones",
          value: "acciones",
          align: "center",
          sortable: false,
        }
      ],

      conceptosBonos: [],
      bonos: [],
      turnos: [],
      areas: [],
      puestos: [],
      maquinas: [],

      errores: [],

      alerta: false,
      loadingTable: false,
      loadingDialog: false,
    }
  },
  methods: {
    nombreMaquina(item) {
      return `${item.marca} - [${item.modelo}]`
    },
    initialize() {
      this.getTurnos();
      this.getAreas();
      this.getDepartamentos();
      this.getPuestos();
      this.getMaquinas();
      this.getBonos();
      this.getConceptosBonos()
    },

    validate() {
      this.errores = [];
      let totalPorcentajes = 0;
      const porcentajes = this.bonoData.bonoConceptos.map(item => parseInt(item.porcentaje));
      for (let i of porcentajes) totalPorcentajes += i;

      if (!this.$refs.form.validate()) {
        this.agregarError(500, "Faltan datos obligatorios");
        return;
      } if (totalPorcentajes != 100) {
        this.agregarError(500, "El porcentaje total debe ser igual a 100");
        return;
      }
      //this.optionDialog == 'Crear' ? this.postBonos() : this.putBonos();
      this.optionDialog == 1 ? this.postBonos() : this.putBonos();
    },


    getTurnos() {
      axios
        .get("Turnos")
        .then(response => {
          this.turnos = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getAreas() {
      axios
        .get("Areas")
        .then(response => {
          this.areas = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getDepartamentos() {
      axios
        .get("Departamento")
        .then(response => {
          this.departamentos = response.data;
        })
        .catch(error => {
          console.log(error)
        })
    },
    getPuestos() {
      axios
        .get("Puestos")
        .then(response => {
          this.puestos = response.data;
        })
        .catch(error => {
          console.log(error);
        })
    },
    getMaquinas() {
      axios
        .get("Maquinas")
        .then(response => {
          this.maquinas = response.data;
        })
        .catch(error => {
          console.log(error);
        })
    },
    getConceptosBonos() {
      axios
        .get("/Bonos/ListarConceptoBonos")
        .then(response => {
          this.conceptosBonos = response.data;
        })
        .catch(error => {
          console.log(error);
        })
    },
    getBonos() {
      this.loadingTable = true;
      axios
        .get("Bonos/Listar")
        .then(response => {
          this.bonos = response.data
        })
        .catch(error => { console.log(error.response) })
        .finally(() => {
          this.loadingTable = false;
        })
    },
    postBonos() {
      this.loadingDialog = true;
      this.bonoData.idTipo = this.bonoData.idCargo;
      axios
        .post("/Bonos/Crear", this.bonoData)
        .then(response => {
          this.getBonos();
          this.hide_dialogBonos();
        })
        .catch(error => {
          console.log(error.response);
          if (error.response) {
            if (error.response.status == 409) {
              this.alerta = true;
              this.errores.push("Existe un Bono Activo con el Mismo Nombre");
            }
          }
        })
        .finally(() => {
          this.loadingDialog = false;
        })
    },
    putBonos() {
      //this.bonoData.idBono =
      this.loadingDialog = true;
      axios
        .put(`/Bonos/Actualizar/${this.bonoData.idBono}`, this.bonoData)
        .then(response => {
          this.getBonos();
          this.hide_dialogBonos();
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response) {
            if (error.response.status == 409) {
              this.alerta = true;
              this.errores.push("Existe un Bono Activo con el Mismo Nombre");
            }
          }
        })
        .finally(() => {
          this.loadingDialog = false;
        })
    },
    deleteBono() {
      if (!this.bonoData || !this.bonoData.idBono) return

      this.dialogDeleteBono = true;
      axios
        .put(`/Bonos/Desactivar/${this.bonoData.idBono}`)
        .then(response => {
          this.getBonos();
          this.hide_dialogDelete();
        })
        .catch((error) => { console.log(error.response) })
        .finally(() => {
          this.dialogDeleteBono = false;
        })
    },

    mostrar_TiposUsuarios() {
      this.dialogEleccion = true;
    },
    async asignarConceptosBonos() {
      this.bonoTipo = parseInt(this.bonoTipo);
      switch (this.bonoTipo) {
        case 1:
          this.bonoData.bonoConceptos = JSON.parse(JSON.stringify(this.conceptosBonos));
          break;
        case 2:
          this.bonoData.bonoConceptos = JSON.parse(JSON.stringify(this.conceptosBonos));
          break;
      }
    },
    async selectTipoUsuario() {
      this.bonoData.bonoConceptos = JSON.parse(JSON.stringify({}));
      this.dialogEleccion = false;

      await this.asignarConceptosBonos();
      this.bonoData.idTipo = this.bonoTipo;
      this.show_dialog();
    },
    show_dialog(item) {
      this.dialog = true;
      //this.optionDialog = item ? "Editar" : "Crear";
      this.optionDialog = item ? 2 : 1;

      if (item) {
        this.bonoData = JSON.parse(JSON.stringify(item));

        this.conceptosBonos.forEach(concepto => {
          let idx = this.bonoData.bonoConceptos.findIndex(consLocal => consLocal.idConceptoBono === concepto.idConceptoBono);
          if (idx !== -1) {
            this.bonoData.bonoConceptos[idx] = { ...this.bonoData.bonoConceptos[idx], concepto }
          } else {
            this.bonoData.bonoConceptos.push(concepto)
          }
        })

      } else {
        this.bonoData.bonoConceptos = JSON.parse(JSON.stringify(this.conceptosBonos));
      }
    },
    hide_dialogBonos() {
      this.$refs.form?.reset();
      this.dialog = false;
      //Object.assign(this.bonoData, this.bonoDataDef);
      this.vaciarErrores();
    },

    show_dialogDelete(item) {
      if (item) {
        Object.assign(this.bonoData, item);
      }
      console.log("Eliminar")
      this.dialogDeleteBono = true;
    },
    hide_dialogDelete() {
      this.dialogDeleteBono = false;
      this.bonoData = JSON.parse(JSON.stringify(this.bonoDataDef));
    },

    agregarError(error = 500, descrip) {
      if (descrip) {
        this.errores.push(descrip)
      } else {
        switch (error) {
          case 500:
            this.errores.push("Error");
            break
          case 401:
            this.errores.push("Hubo un problema con los datos proporcionados.");
            break
          case 409:
            this.errores.push("El recurso que intentas crear ya existe.")
            break;
          default:
            this.errores.push("Error.")
            break
        }
      }
      let data = new Set(this.errores);
      this.errores = [...data];
    },
    vaciarErrores() {
      this.errores = JSON.parse(JSON.stringify({}))
    }

  },
  mounted() {
    this.initialize();
  },
}
</script>

<style scoped>
.my-button-class {
  color: rgb(0, 123, 255) !important;
}

.v-btn--active.my-button-class {
  background-color: rgb(0, 123, 255) !important;
  color: white !important;
}
</style>